<div class="row g-0 passport-root">
  <div class="" fxFlex="25" fxFlex.lt-md="100">
    <app-sidebar
      (secondarySideNavStatus)="updateSecondarySideNavStatus($event)"
    ></app-sidebar>
  </div>
  <div fxFlex="75" fxFlex.lt-md="100">
    <div>
      <router-outlet #outlet="outlet"></router-outlet>
    </div>
  </div>
</div>
